import { render, staticRenderFns } from "./ListSkeleton.vue?vue&type=template&id=a471a216&scoped=true&"
import script from "./ListSkeleton.vue?vue&type=script&lang=js&"
export * from "./ListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ListSkeleton.vue?vue&type=style&index=0&id=a471a216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a471a216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a471a216')) {
      api.createRecord('a471a216', component.options)
    } else {
      api.reload('a471a216', component.options)
    }
    module.hot.accept("./ListSkeleton.vue?vue&type=template&id=a471a216&scoped=true&", function () {
      api.rerender('a471a216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/ListSkeleton/ListSkeleton.vue"
export default component.exports